<template>
	<div>
		<div
			v-if="loading"
			class="d-flex justify-center align-center"
			:style="{ height: `${$vuetify.breakpoint.height - 130}px` }"
		>
			<v-progress-circular
				indeterminate
				size="45"
				color="primary"
			></v-progress-circular>
		</div>
		<v-row v-else-if="movements.length">
			<v-col
				v-for="(movement, index) in movements"
				:key="index"
				md="4"
				sm="6"
				cols="12"
				class="pa-2"
			>
				<v-card rounded="xl">
					<v-card-title class="primary--text text--lighten-2 pb-0">
						{{
							moment.utc(movement.Date).locale($i18n.locale).format('dddd') + ' ' +
							moment.utc(movement.Date).format('DD-MM-YYYY')
						}}
					</v-card-title>
					<v-card-text >
						<div
							v-for="(state, index) in movement.BusStatus"
							:key="index"
							class="d-flex flex-wrap elevation-1 rounded-lg grey lighten-4 py-3 px-4 mt-2"
						>
							<span class="font-weight-bold">
								{{state.Status}}
							</span>
							<v-spacer/>
							<span class="green--text text--darken-1">
								{{
									moment(state.Time)
										.format('hh:mm a')
										.replace(/am|pm/, match => ({ am: 'ص', pm: 'م' })[match])
								}}
							</span>
						</div>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<p v-else class="text-h6 text-center mt-16">
			{{$t('messages.no-movements-yet')}}
			<v-icon color="grey darken-2" size="28" class="ms-1">mdi-alert-octagon-outline</v-icon>
		</p>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'LatestMovements',

	data: () => ({
		loading: false,
		moment,

		movements: []
	}),

	created() {
		this.loading = true;
		this.$store.dispatch('passengers/fetchPassengerMovements', {
			id: this.$route.params.id
		}).then((data) => {
			this.movements = data || [];
		}).finally(() => {
			this.loading = false;
		})
	}
}
</script>

<style>

</style>